import {Component} from '@angular/core';

@Component({
  selector: 'mz-sidenav-divider',
  templateUrl: './sidenav-divider.component.html',
  styleUrls: ['./sidenav-divider.component.scss'],
})
export class MzSidenavDividerComponent {
}
